<template>
  <b-card :title="$t('message.Guideline.progress')" class="mb-2">
    <div class="row big-font">
      <div class="col-11 offset-1 border-left-custom pl-5">
        <div v-for="key in steps" :key="key" :class="{ 'font-weight-bold active' : activeKey === key }">{{ $t('message.Guideline.phase' + key) }} <font-awesome-icon v-if="activeKey === key" icon="circle" size="lg" class="dot"/></div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { GuidelinePhases } from '@/lib/guideline.js';

export default {
  name: 'phase-preview-left',
  components: {},
  props: ['guideline'],
  data () {
    return {
      guidelinePhases: GuidelinePhases,
    }
  },
  computed: {
    isParallel() {
      return this.guideline.review_mode === 'parallel';
    },

    /**
     * The ordered phase keys shown in the progress bar. In parallel mode the
     * sequential committee/ND review steps (50/70/80) collapse into a single
     * "parallel review" step (52); the flow rejoins the shared lifecycle at 100.
     */
    steps() {
      const review = this.isParallel
        ? [this.guidelinePhases.parallelReview, this.guidelinePhases.parallelReviewEnd]
        : [
            this.guidelinePhases.uploadedForReview,
            this.guidelinePhases.uploadReviewedEnd,
            this.guidelinePhases.reviewByNationalDelegates,
          ];

      return [
        this.guidelinePhases.draft,
        this.guidelinePhases.submitted,
        this.guidelinePhases.preApproved,
        this.guidelinePhases.uploadedForGpcReview,
        this.guidelinePhases.uploadGpcReviewedEnd,
        ...review,
        this.guidelinePhases.reviewByNationalDelegatesEnd,
        this.guidelinePhases.gpcFinalApproval,
        this.guidelinePhases.boardApproval,
        this.guidelinePhases.boardApprovalApproved,
        this.guidelinePhases.finalPublish,
      ];
    },

    /** The phase key of the step that should be highlighted for the current phase. */
    activeKey() {
      const p = this.guideline.phase;

      if (this.isParallel &&
          p >= this.guidelinePhases.parallelReview &&
          p <= this.guidelinePhases.parallelReviewEnd) {
        // 52 + 54 fold into "Under review"; 56 (office decision) is its own step.
        return p === this.guidelinePhases.parallelReviewEnd
          ? this.guidelinePhases.parallelReviewEnd
          : this.guidelinePhases.parallelReview;
      }

      if (p < this.guidelinePhases.submitted) return this.guidelinePhases.draft;
      if (p < this.guidelinePhases.preApproved) return this.guidelinePhases.submitted;
      if (p < this.guidelinePhases.uploadedForGpcReview) return this.guidelinePhases.preApproved;
      if (p < this.guidelinePhases.uploadGpcReviewedEnd) return this.guidelinePhases.uploadedForGpcReview;
      if (p < this.guidelinePhases.uploadedForReview) return this.guidelinePhases.uploadGpcReviewedEnd;
      if (p < this.guidelinePhases.uploadReviewedEnd) return this.guidelinePhases.uploadedForReview;
      if (p < this.guidelinePhases.reviewByNationalDelegates) return this.guidelinePhases.uploadReviewedEnd;
      if (p < this.guidelinePhases.reviewByNationalDelegatesEnd) return this.guidelinePhases.reviewByNationalDelegates;
      if (p < this.guidelinePhases.gpcFinalApproval) return this.guidelinePhases.reviewByNationalDelegatesEnd;
      if (p < this.guidelinePhases.boardApproval) return this.guidelinePhases.gpcFinalApproval;
      if (p < this.guidelinePhases.boardApprovalApproved) return this.guidelinePhases.boardApproval;
      if (p < this.guidelinePhases.finalPublish) return this.guidelinePhases.boardApprovalApproved;
      return this.guidelinePhases.finalPublish;
    }
  },
  mounted () {},
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .border-left-custom{
    border-style: solid;
    border-width: 0 0 0 4px;
    border-color: #545454;
  }

  .big-font{
    font-size: 1.3em;
  }

  .active{
    font-size: 1.5em;

    .dot {
      position: absolute;
      left: -19px;
    }
  }

  h2 {
    color: #6f6f6f;
    padding-bottom: 0.7rem;
    border-bottom: 2px solid #dddddd;
    margin-bottom: 1em;
    font-weight: 600;
  }
</style>
